import type {ImageUrl} from "@atg-ui/avatar";

export type ChannelId = string;

export type Author = {
    id: number;
    displayName?: string;
    firstName?: string;
    lastName?: string;
    imageUrl?: ImageUrl;
};

export type MyChannelStats = {
    nrOfUnreadComments: number;
};

export type OnlineMember = {
    firstName: string;
    lastName: string;
    imageUrl?: ImageUrl;
    online?: boolean;
};

export type OnlineInfo = {
    members: OnlineMember[];
    visible: boolean;
    showExactNum?: boolean;
};

/**
 * @deprecated SHould not be used in new code.
 */
export type ChatAvatarProps = {
    imageUrl: ImageUrl | null;
    size?: number;
    online?: boolean;
    alt?: string;
    showTooltip?: boolean;
};

export enum AuthorType {
    MEMBER = "MEMBER",
    SYSTEM = "SYSTEM",
    TEAM_CAPTAIN = "TEAM_CAPTAIN",
    BET_PLACER = "BET_PLACER",
    MODERATOR = "MODERATOR",
    GHOST_WRITER = "GHOST_WRITER",
    AGENCY_ADMIN = "AGENCY_ADMIN",
    INFO = "INFO",
    HOST = "HOST",
}

export type MessageReaction = {
    reactionId: number;
    emoji: string;
    firstName: string;
    lastName: string;
    memberId: number;
};

export type Message = {
    __typename?: "message";
    id: number;
    authorType: AuthorType;
    channelId: ChannelId;
    createdAt: string;
    timestamp?: string;
    updatedAt?: string;
    text: string;
    user: Author;
    hidden?: boolean;
    pinned?: boolean;
    reactions?: Array<MessageReaction>;
};
